import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';

import { useStore, useTranslation } from '../../../../../hooks';
import { isMobile } from '../../../../../helpers';
import { formatTime } from '../../../../helpers';
import { T } from '../../../../../constants';

export const JackPotExpireDate: React.FC<{ x: number, y: number }> = observer(({ x, y }) => {
  const t = useTranslation();
  const { jackpotStore } = useStore();
  const { jackPotExpireTime, jackPotExpireDate, setJackPotExpireTime, setIsAllowDoJackpotAction } = jackpotStore;

  useEffect(() => {
    if (!jackPotExpireDate) return;

    let intervalId: NodeJS.Timeout;

    const tick = () => {
      const dateNow = new Date().getTime();
      const endTime = new Date(jackPotExpireDate).getTime();
      const difference = endTime - dateNow;

      if (difference <= 0) {
        setJackPotExpireTime(0);
        jackpotStore.handleOpenJackpotRemainingScene();
        clearInterval(intervalId);
      } else {
        setJackPotExpireTime(difference);
      }
    };

    tick();
    intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [jackPotExpireDate]);

  const displayTime = jackPotExpireTime > 0 ? formatTime(jackPotExpireTime) : '00:00';

  useEffect(() => {
    if (jackPotExpireTime < 3000) {
      setIsAllowDoJackpotAction(false);
    }
  }, [jackPotExpireTime]);

  return (
    <Container x={x} y={y} {...({ name: 'JackPotExpireTimeContainer' } as any)}>
      <Text
        anchor={0.5}
        resolution={2}
        {...({ interactive: true } as any)}
        style={{ fill: '#FFFFFF', fontSize: isMobile() ? 13 : 16 }}
        text={`${t(T.EXPIRE)} ${displayTime}`}
      />
    </Container>
  );
});
